import { thumbHashToDataURL } from 'thumbhash';

/**
 * Turns the ~25 stored bytes into a blurred data URL.
 *
 * Cached because a gallery re-renders constantly while scrolling and the
 * decode, though cheap, is not free at a few hundred tiles.
 */
const cache = new Map<string, string>();

export function thumbhashUrl(hash: string | null): string | undefined {
  if (!hash) return undefined;
  const hit = cache.get(hash);
  if (hit) return hit;
  try {
    const bytes = Uint8Array.from(atob(hash), (char) => char.charCodeAt(0));
    const url = thumbHashToDataURL(bytes);
    cache.set(hash, url);
    return url;
  } catch {
    return undefined;
  }
}
